const userAgent = global.navigator.userAgent;
export const pixelRatio = global.devicePixelRatio || 1;
const screen = global.screen;
const width = screen.width * pixelRatio;
const height = screen.height * pixelRatio;

export const isWindowsPhone = userAgent.indexOf('IEMobile') !== -1;
export const isIPhone = userAgent.indexOf('iPhone') !== -1 && !isWindowsPhone;
export const isIPad = userAgent.indexOf('iPad') !== -1 && !isWindowsPhone;
export const isIOS = isIPhone || isIPad;
export const isIPhoneX = isIOS && width === 1125 && height === 2436;
// case for iPhoneXSMax and iPhoneXR
export const isIPhoneXSMax = isIOS && ((width === 1242 && height === 2688) || (width === 828 && height === 1792));
export const isAndroid = !!~userAgent.indexOf('Android');
export const isEmbedded = userAgent.indexOf('embedded') !== -1 || (isAndroid && !!~userAgent.indexOf('wv'));
export const isIE = userAgent.indexOf('MSIE ') > -1 || userAgent.indexOf('Trident/') > -1;
export const isIOSEmbeddedAndStandalone = isEmbedded && process.env.STANDALONE_ENV;
export const getOsVersion = (useragent) => {
  const match = useragent.match(/OS ((\d+_?){2,3})\s/);
  const version = match && match[1];
  return version ? parseInt(version.split('_')[0], 10) : null;
};
export const osMajorVersion = getOsVersion(userAgent);
